import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorization-modal',
  templateUrl: './authorization-modal.component.html',
  styleUrls: ['./authorization-modal.component.scss']
})
export class AuthorizationModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
